import { motion } from "framer-motion";
import { Brand } from "./Brand";

export const LoadingView = ({ message = "On retrouve ta table…" }: { message?: string }) => (
  <main className="loading-view" aria-live="polite">
    <Brand />
    <div className="card-loader" aria-hidden="true">
      <motion.span
        animate={{ y: [0, -7, 0], rotate: [-4, 3, -4] }}
        transition={{ duration: 1.25, ease: "easeInOut", repeat: Infinity }}
      />
    </div>
    <p>{message}</p>
  </main>
);
